import { Fragment } from "react";

const PLACEHOLDER = /(<[A-Z]+_\d+>)/;
// Defence in depth: the server already redacted the text, so anything below
// that still looks like a contact or a long number is hidden, never shown.
const LEAK =
  /[\w.+-]+@[\w-]+(?:\.[\w-]+)+|https?:\/\/\S+|\+?\d[\d\s().-]{6,}\d/g;
const HIDDEN = "<HIDDEN_1>";

/** Redacted text with the placeholders marked; there is no copy control. */
export function RedactedText({ text }: { text: string }) {
  const safe = text.replace(LEAK, HIDDEN);
  return (
    <p className="whitespace-pre-wrap break-words text-body text-fg">
      {safe.split(PLACEHOLDER).map((part, index) =>
        PLACEHOLDER.test(part) || part === HIDDEN ? (
          <mark
            key={index}
            className="rounded-sm bg-accent-subtle px-1 font-mono text-mono text-accent-fg"
          >
            {part}
          </mark>
        ) : (
          <Fragment key={index}>{part}</Fragment>
        ),
      )}
    </p>
  );
}
